module.exports = "<section class=\"ai-html-preview-wrapper\"\n         ng-style=\"{width: ai.width, height: ai.height}\"\n         ng-class=\"{'portrait': ai.prHeight > ai.prWidth,'landscape': ai.prHeight < ai.prWidth}\"   >\n    <img src=\"" + require("./../../../../images/ai-preview/age-slider.png") + "\" id=\"ageSlider\" alt=\"age-slider\" ng-if=\"!ai.displaySlider\">\n    <img src=\"" + require("./../../../../images/ai-preview/persona_Landscape_1920x1080.png") + "\" alt=\"persona\" class=\"persona\" ng-if=\"ai.prHeight < ai.prWidth\">\n\n</section>\n";


//////////////////
// WEBPACK FOOTER
// ./sources/components/common/ai-html-preview/ai-html-preview.html
// module id = 834
// module chunks = 0